import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelBenchmarkInsightProductOverlay from 'lumen/components/hotel/benchmark-insight/product-overlay';
import type HotelBenchmarkInsightTermsAndConditionsController from 'lumen/controllers/hotel/benchmark-insight/terms-and-conditions';

interface HotelBenchmarkInsightTermsAndConditionsSignature {
  Args: {
    controller: HotelBenchmarkInsightTermsAndConditionsController;
    model: unknown;
  };
}

<template>
  <HotelBenchmarkInsightProductOverlay @position="center">
    <div class="terms-and-conditions flex flex-row gap-1000">
      <h1 class="w-1/2">
        {{#if @controller.access.hasBenchmarkInsightTermsAndConditionsAccept}}
          {{t "benchmark_insight.terms_and_conditions.title.admin"}}
        {{else}}
          {{t "benchmark_insight.terms_and_conditions.title.viewer"}}
        {{/if}}
      </h1>

      <div class="flex w-1/2 flex-col justify-center">
        {{#if @controller.access.hasBenchmarkInsightTermsAndConditionsAccept}}
          <p class="mb-600">{{t
              "benchmark_insight.terms_and_conditions.body.admin.1"
            }}</p>

          <p class="mb-600">
            {{t
              "benchmark_insight.terms_and_conditions.body.admin.2"
              class="prism-link"
              htmlSafe=true
              url="https://www.mylighthouse.com/terms-and-conditions"
            }}
          </p>

          <PrismButton
            @buttonType="brand"
            @iconAfter="arrow-right"
            @label={{if
              @controller.access.hasBenchmarkInsightDataStaffOnly
              (t "benchmark_insight.view_as_staff_user")
              (t "benchmark_insight.terms_and_conditions.body.button")
            }}
            data-test-id="terms-and-conditions-accept"
            {{on "click" @controller.onClickContinue}}
          />
        {{else}}
          <div class="flex flex-col gap-600">
            <p>{{t "benchmark_insight.terms_and_conditions.body.viewer"}}</p>

            {{#if @controller.access.hasBenchmarkInsightDataStaffOnly}}
              <PrismButton
                @buttonType="brand"
                @iconAfter="arrow-right"
                @label={{t "benchmark_insight.view_as_staff_user"}}
                data-test-id="terms-and-conditions-staff"
                {{on "click" @controller.onClickContinue}}
              />
            {{/if}}
          </div>
        {{/if}}
      </div>
    </div>
  </HotelBenchmarkInsightProductOverlay>
</template> satisfies TOC<HotelBenchmarkInsightTermsAndConditionsSignature>;
